import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type SettingsState = {
  themeMode: 'light' | 'dark';
};

const initState: SettingsState = {
  themeMode: 'light',
};

export const useSettings = createStore({
  name: 'website-settings-state',
  devtools: isDevtoolsEnabled,
  persist: true,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setThemeMode: handler('themeMode'),
  };
});
